import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./work-contents.css";
import { Link } from 'react-router-dom';
import { Carousel, Icon } from 'antd';
import { projects } from '../../utils/projects';
import Feature from "./category/Feature";
import stickers from '../../assets/stickers-01.png'
import branding from '../../assets/branding-01.png'
import illustrate from '../../assets/illustration-01.png'
import websystem from '../../assets/webmobilesys-01.png'
import photography from '../../assets/photography-01.png'
import layout from '../../assets/layout-01.png'

class WorkDetails extends Component {
  handleCategoryIcon (cat) {
    switch(cat) {
      case 'branding' :
        return branding
      case 'illustrate' :
        return illustrate
      case 'layout' :
        return layout
      case 'photography' :
        return photography
      case 'stickers' :
        return stickers
      case 'websystem' :
        return websystem
      default :
        return null
    }
  }
  render() {
    const id = this.props.match.params.id;
    const selected = projects.filter((item, i) => item.key === id);
    return (
      <div className="page-container" style={{backgroundColor: 'whitesmoke'}}>
      
        <div className="works-content">
        <Link to="/work"><p className="backtowork"><Icon type="left-circle-o" /> Back to Work</p></Link>
          <div className="work-title">
            <h3>{selected[0].name}</h3>
            <div className="work-icons">
              <ul align="center">
              {
                  selected[0].category.map((cat,i) => 
                    <li className="work-icon" ><img src={this.handleCategoryIcon(cat)} alt={cat}/></li>
                    // console.log(cat)
                  )
                }
              </ul>
            </div>
          </div>
          <Carousel autoplay effect="fade">
            {
              selected[0].photos.map((photo) =>
                <div key={photo.id}>
                  <img src={photo.src} alt={photo.id} className="" />
                </div>
                )
            }
          </Carousel>
          <div className="works-content-txt">
            {selected[0].desc}
          </div>
          <Feature
            data = {selected[0].features}
          />
        </div>
        <Link to="/contact"><p className="hireus">Hire Us <Icon type="right-circle-o" /></p></Link>
      </div>
      );
  }
}

export default withRouter(WorkDetails);



// WEBPACK FOOTER //
// ./src/components/pages/WorkDetails.js